export default "__VITE_ASSET__rPAfgIsV__"